/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const getCampaignUsersDataSchema = z.object({
	perPage: z.number(),
	page: z.number(),
})

export type GetCampaignUsersDataSchema = z.infer<typeof getCampaignUsersDataSchema>
